import { withHandlers, withState, compose } from 'recompose';
import { without } from 'lodash';
import { getPath } from '../../utils';

const withEntitiesLoading = compose(
  withState(
    'entitiesLoading',
    'setEntitiesLoading',
    () => ([]),
  ),
  withHandlers({
    setLoading: props => (row, isLoading) => {
      const {
        entitiesLoading,
        setEntitiesLoading,
      } = props;
      const entityPath = getPath(row);
      const entityPathString = entityPath.toString();
      if (isLoading && !entitiesLoading.includes(entityPathString)) {
        setEntitiesLoading([...entitiesLoading, entityPathString]);
      } else if (!isLoading && entitiesLoading.includes(entityPathString)) {
        setEntitiesLoading(without(entitiesLoading, entityPathString));
      }
    },
  }),
);

export default withEntitiesLoading;

